export const LATITUDE_DEFAULT = 27.950575
export const LONGITUDE_DEFAULT = -82.4571776
export const LOCATION_DEFAULT = {
    id: 'ChIJ4dG5s4K3wogRY7SWr4kTX6c',
    value: 'Tampa, FL, USA'
  }
